module.exports = __webpack_public_path__ + "img/google-logo.ecc84433.png";